import React from "react";
import "./LoadingBar.css";

const LoadingBar = ({ progress }) => {
  // If progress is undefined or not a valid number,
  // just show minimal "Loading..." text
  if (typeof progress !== "number" || isNaN(progress)) {
    return (
      <div className="loading-text-container">
        Loading...
      </div>
    );
  }

  // Otherwise, validate and clamp progress between 0 and 100
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  // A single fill color (instead of color-coded)
  const fillColor = "#4535BF";

  return (
    <div
      className="loading-bar-container"
      aria-label={`Loading progress: ${clampedProgress}%`}
    >
      <div
        className="loading-bar-fill"
        style={{
          width: `${clampedProgress}%`,
          backgroundColor: fillColor,
        }}
      />
      <span className="loading-bar-text">{clampedProgress}%</span>
    </div>
  );
};

export default LoadingBar;
